import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import { FaUserLarge } from "react-icons/fa6";
import { MdOutlineAddBusiness } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { PiBuildingApartmentBold } from 'react-icons/pi';
import { MdOutlineApartment } from 'react-icons/md';
import { IoIosArrowDown } from "react-icons/io";
import { useLocation } from 'react-router-dom';
import { MdPerson4 } from "react-icons/md";
import { FaShippingFast } from "react-icons/fa";
import { MdRateReview } from "react-icons/md";
import { MdDashboardCustomize } from "react-icons/md";

const Sidebar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(0);
  const [expandedBusiness, setExpandedBusiness] = useState(false);

  const sidebarOptions = [
    { id: 1, icon: <MdDashboardCustomize />, name: 'Dashboard', path: "/home/dashboard" },
    { id: 2, icon: <FaUserLarge />, name: 'Customers', path: "/home/customers" },
    { id: 3, icon: <PiBuildingApartmentBold />, name: 'Providers', path: "/home/providers" },
    { id: 4, icon: <MdOutlineApartment />, name: 'Categories', path: "/home/categories" },
    {
      id: 5,
      icon: <MdOutlineAddBusiness />,
      name: 'Business',
      subcategories: [
        { id: 6, name: 'Approved', path: "/home/business/approved" },
        { id: 7, name: 'Pending', path: "/home/business/pending" },
        { id: 8, name: 'Rejected', path: "/home/business/rejected" },
      ]
    },
    { id: 9, icon: <MdPerson4 />, name: 'Agents', path: "/home/agents" },
    { id: 10, icon: <FaShippingFast />, name: 'Bookings', path: "/home/bookings" },
    { id: 11, icon: <MdRateReview />, name: 'Reviews', path: "/home/reviews" },
  ];

  const handleOptionClick = (id, path, name) => {
    setSelectedOption(id);
    navigate(path);
    if (name === 'Business') setExpandedBusiness(!expandedBusiness);
  };

  const getSelectedMenuOption = () => {
    if (pathname.includes('/business/')) {
      const businessSubcategory = sidebarOptions[4].subcategories.find(sub => pathname.includes(sub.path));
      setSelectedOption(businessSubcategory ? businessSubcategory.id : 5);
      setExpandedBusiness(true);
    } else {
      const matchedOption = sidebarOptions.find(option => option.path === pathname);
      setSelectedOption(matchedOption ? matchedOption.id : pathname.includes('categories/') ? 4 : pathname.includes('bookings/') ? 10 : (pathname.includes('reviews/') ? 11 : 0));
    }
  };

  useEffect(() => {
    getSelectedMenuOption();
  }, [pathname]);

  return (
    <div className="sidebar-main">
      <div>
        {sidebarOptions.map((option) => (
          <div key={option.id}>
            <div
              className={`sidebar-name ${selectedOption === option.id ? 'selected' : ''}`}
              onClick={() => handleOptionClick(option.id, option.path, option.name)}
            >
              <div className='category-name'>
                {option.icon}
                <p>{option.name}</p>
              </div>
              {option.subcategories && (
                <IoIosArrowDown
                  onClick={(e) => {
                    e.stopPropagation();
                    setExpandedBusiness(!expandedBusiness);
                  }}
                />
              )}
            </div>

            {option.subcategories && expandedBusiness && (
              <div className="subcategories">
                {option.subcategories.map((sub) => (
                  <div
                    className={`subcategory-name ${selectedOption === sub.id ? 'selected' : ''}`}
                    key={sub.id}
                    onClick={() => handleOptionClick(sub.id, sub.path)}
                  >
                    <p>{sub.name}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
